import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { completeGoogleAuthLogin } from "./cognitoAuth";
import { redirectUser } from "../modules/newProviderApp/actions/apis";
import { PlaybackLoader } from "../shared/components/globalLoader/playbackLoader";
import { ShowAlert } from "../common/alert";

export function GoogleAuthCallback({ history, location }) {
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        completeGoogleAuthLogin(
            location.search,
            location.hash,
            (profile) => {
                const path = "/notes";
                redirectUser(path);
            },
            (error) => {
                const message = error?.message || "Google sign-in failed. Please try again.";
                ShowAlert(message, "error");
                history.replace("/login");
            }
        );
    }, [history, location.search, location.hash]);

    return <PlaybackLoader />;
}

export default withRouter(GoogleAuthCallback);
